import React from "react";
import { Container } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import {
  Heading1,
  Body1,
} from "../../../components/value-cssmodules/TextComponent";
import styles from "./Title.module.scss";
import MainButton from "../../../components/Button/MainButton";

const Title = () => {
  return (
    <header className={styles.title}>
      <Container>
        <Heading1>
          <FormattedMessage
            id={"nav.headingTitleDHP"}
            defaultMessage={
              "Sell your own tailor patterns and have time to creating new ones"
            }
          />
        </Heading1>
        <Body1>
          <FormattedMessage
            id={"nav.bodytitleDHP"}
            defaultMessage={
              "You are passionate about sewing, a recognizable designer - decide for yourself the price for patterns, earn as much as you want."
            }
          />
        </Body1>

        <MainButton className={styles.mainButton}>
          {/* <FormattedMessage id="nav." defaultMessage="" /> */}
          <FormattedMessage
            id={"nav.startSellingPatterns"}
            defaultMessage={"Start selling patterns"}
          />
        </MainButton>
      </Container>
    </header>
  );
};

export default Title;
